<template>
    <WarehouseWikiComponent></WarehouseWikiComponent>
    <CustomerServiceWikiComponent></CustomerServiceWikiComponent>
    <AccountingWikiComponent></AccountingWikiComponent>
    <FollowUpDeliveriesWikiComponent></FollowUpDeliveriesWikiComponent>
  </template>
  
  
  <script>
  import { FilterMatchMode } from "primevue/api";
  import axios from "axios";
  import { getAuth } from "firebase/auth";
  import { config } from "@/assets/config.js";
  import { useAuthStore } from "@/stores/auth.js";
  import { useRoute, useRouter } from 'vue-router';
  import Panel from "primevue/panel";
import Button from "primevue/button";
import FloatLabel from "primevue/floatlabel";
import AutoComplete from "primevue/autocomplete";
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import Calendar from 'primevue/calendar';
import Divider from "primevue/divider";
import FileUpload from "primevue/fileupload";
import ContextMenu from "primevue/contextmenu";
import WarehouseWikiComponent from "./WarehouseWikiComponent.vue";
import CustomerServiceWikiComponent from "./CustomerServiceWikiComponent.vue";
import AccountingWikiComponent from "./AccountingWikiComponent.vue";
import FollowUpDeliveriesWikiComponent from "./FollowUpDeliveriesWikiComponent.vue";
  
  export default {
    components: {
      Panel,
      Button,
      FloatLabel,
      AutoComplete,
      InputText,
      Dropdown,
      Calendar,
      Divider,
      FileUpload,
      ContextMenu,
      WarehouseWikiComponent,
      CustomerServiceWikiComponent,
      AccountingWikiComponent,
      FollowUpDeliveriesWikiComponent
    },
  
    data() {
    return {
      authStore: useAuthStore(),
      warehousereclamationsearch: [],
      supplierSuggestions: [],
      articleSuggestions: [],
      createdbySuggestions: [],
      filters: {
        supplier: { value: "", matchMode: FilterMatchMode.CONTAINS },
        order: { value: "", matchMode: FilterMatchMode.CONTAINS },
        incomegoodsnumber: { value: "", matchMode: FilterMatchMode.CONTAINS },
        article: { value: "", matchMode: FilterMatchMode.CONTAINS },
      },
      uploadToken: null,
      loading: true,
      dialogOpen: false,
      size: "small",
      createdby: null,
      date: null,
      configURL: config.api_url,
      supplier: null,
      order: null,
      incomegoodsnumber: null,
      article: null,
      reason: null,
      attachment: null,
      should: null,
      is: null,
      comment: null,
      displayName: null,
      selectedEntry: null,
      completeddate: null,
      reklaausgang: null,
      accounting_action: null,
      showaccounting_actionDropdown: false,
      reklaausgangOptions: [
        "Zurückgeschickt",
        "Outlet",
        "Eingelagert",
        "Nachgeliefert",
        "Ersatzlieferung",
        "Keine Antwort -> Kommentar",
        "Andere... -> Kommentar",
        "Buchhaltung"
      ],
      reasonOptions: [
        "Mengendifferenz",
        "Beschädigt",
        "Nicht geliefert",
        "Falsch geliefert",
        "Qualitätsdifferenz",
        "Backorderüberschreitung",
        "Andere... -> Kommentar",
      ],
      accounting_actionOptions: ["Rechnung", "Gutschrift"],
      contextMenuItems: [],
contextEntry: null,
claimFilterId: null,
    };
  },
  };
  </script>
  
  
  
  <style lang="scss" scoped>
  /* 🔹 Standard Button & Input Styles */
.cua-modal-btn {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
}
.reklamation-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap; /* Optional: allow wrapping on smaller screens */
}

.reklamation-section {
  flex: 1 1 45%;
  min-width: 300px;
}

  </style>
  